import { A, useLocation } from '@solidjs/router';
import { For, Show } from 'solid-js';
import { IconMenuSelected } from '~/components/ui/Icons';
import { TranslationKeys, useLocalization } from '~/hooks/useLocalization';
import { cn } from '~/utils/classnames';

export interface MenuProps {
  title: TranslationKeys;
  link: string;
}

export const menus = [
  {
    title: TranslationKeys.HOME,
    link: '/',
  },
  {
    title: TranslationKeys.PROPERTIES,
    link: '/properties',
  },
];

export const Menu = () => {
  const location = useLocation();
  const { t } = useLocalization();

  const isActive = (itemLink: string) => {
    if (itemLink === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(itemLink);
  };

  return (
    <div class="flex items-center gap-6">
      <For each={menus}>
        {(item) => (
          <A href={item.link}>
            <div class="relative flex flex-col items-center justify-center gap-[5px]">
              <div class={cn('text-[#656C81] hover:text-primary-color', isActive(item.link) && 'text-primary-color')}>{t(item.title)}</div>
              <Show when={isActive(item.link)}>
                <IconMenuSelected class="absolute bottom-[-10px]" color="var(--primary-color)" />
              </Show>
            </div>
          </A>
        )}
      </For>
    </div>
  );
};
